import { render } from "./InsuranceSuccessPage.vue?vue&type=template&id=e8f39ac8&scoped=true"
import script from "./InsuranceSuccessPage.vue?vue&type=script&lang=js"
export * from "./InsuranceSuccessPage.vue?vue&type=script&lang=js"

import "./InsuranceSuccessPage.vue?vue&type=style&index=0&id=e8f39ac8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8f39ac8"]])

export default __exports__